import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { validate as validateUuid } from 'uuid';

import useGetRouteHash from 'hooks/get-route-hash.hooks';

export const useSessionUuidParamAdmin = () => {
	const session = useParams<{ session: string }>().session;
	const hash = useGetRouteHash();

	return useMemo(() => {

		/* hash check is for platform app iframe rendering */
		if (hash) {
			const regex = /#path=\/session\/(.+?)(?:__|$)/;
			const hashSessionUuid = hash.match(regex)?.[1];
			if (hashSessionUuid && validateUuid(hashSessionUuid)) {
				return hashSessionUuid;
			}
		}

		return session;
	}, [hash, session]);
};

export const useSessionUuid = () => {
	const params = useParams<{ sessionUuid: string }>();
	return useMemo(() => params?.sessionUuid, [params?.sessionUuid]);
};

export const useSessionUuidParamModerator = () => {
	const params = useParams<{ session_uuid: string }>();
	return useMemo(() => params?.session_uuid, [params?.session_uuid]);
};
